export default "__VITE_ASSET__8375ae14__"